var Backbone, SharedAjaxErrorTemplate, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedAjaxErrorTemplate = require('../../ajax_error.html.mustache');

SharedAjaxErrorView = (function(superClass) {
  extend(SharedAjaxErrorView, superClass);

  function SharedAjaxErrorView() {
    return SharedAjaxErrorView.__super__.constructor.apply(this, arguments);
  }

  SharedAjaxErrorView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedAjaxErrorTemplate;
  };

  SharedAjaxErrorView.prototype.render = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$container.html(toHtml(this.template, hash, this.I18nScope));
      this.bindEvents();
      return this.$container;
    }
  };

  SharedAjaxErrorView.prototype.bindEvents = function() {
    return $(".error_reload", this.$container).on("click", function() {
      return window.location.reload();
    });
  };

  return SharedAjaxErrorView;

})(Backbone.View);

module.exports = SharedAjaxErrorView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9hamF4X2Vycm9yX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3NoYXJlZC9mcm9udGVuZC92aWV3cy9hamF4X2Vycm9yX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsc0RBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2IsdUJBQUEsR0FBMEIsT0FBQSxDQUFRLGdDQUFSOztBQUVwQjs7Ozs7OztnQ0FFSixVQUFBLEdBQWEsU0FBQTtJQUNYLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO0VBRkQ7O2dDQUliLE1BQUEsR0FBUyxTQUFDLElBQUQ7SUFDUCxJQUFHLGdEQUFIO01BQ0UsSUFBQyxDQUFBLFVBQUQsR0FBYyxJQUFJLENBQUM7TUFDbkIsSUFBQyxDQUFBLFVBQVUsQ0FBQyxJQUFaLENBQWlCLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFsQixFQUF3QixJQUFDLENBQUEsU0FBekIsQ0FBakI7TUFDQSxJQUFDLENBQUEsVUFBRCxDQUFBO2FBQ0EsSUFBQyxDQUFBLFdBSkg7O0VBRE87O2dDQU9ULFVBQUEsR0FBYSxTQUFBO1dBQ1gsQ0FBQSxDQUFFLGVBQUYsRUFBa0IsSUFBQyxDQUFBLFVBQW5CLENBQThCLENBQUMsRUFBL0IsQ0FBa0MsT0FBbEMsRUFBMEMsU0FBQTthQUN4QyxNQUFNLENBQUMsUUFBUSxDQUFDLE1BQWhCLENBQUE7SUFEd0MsQ0FBMUM7RUFEVzs7OztHQWJtQixRQUFRLENBQUM7O0FBa0IzQyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
